import React from 'react';
import { ApplicationEmptyStateTemplate } from 'themes/components';

function ApplicationEmptyState(props) {
    return <ApplicationEmptyStateTemplate {...props} />
}

export default ApplicationEmptyState;